import React, { Component } from "react";

class ViewProfileDetails extends Component {
	static slug = "urm-view-profile-details";
	render() {
		if (this.props.__render_view_profile_details) {
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: this.props.__render_view_profile_details
					}}
				></div>
			);
		}
		return null;
	}
}

export default ViewProfileDetails;
